// Diccionario eventKey → { color, label } para los badges del feed de actividad.
// Catálogo derivado de TAB_AUDIT_EVENT_TYPES (esquema control). Si el backend
// agrega nuevos eventKey, el badge cae al default y sigue mostrándose.

const CATEGORY_COLOR = {
  security: "warning",
  user_management: "info",
  master_data: "success",
  rbac: "secondary",
  data_access: "default",
};

const EVENT_LABEL = {
  login_success: "Login",
  login_failed: "Login failed",
  account_locked: "Account locked",
  account_unlocked: "Account unlocked",
  password_changed: "Password changed",
  password_reset_requested: "Password reset requested",
  password_reset_completed: "Password reset completed",
  session_started: "Session started",
  session_ended: "Session ended",
  user_created: "User created",
  user_updated: "User updated",
  user_deactivated: "User deactivated",
  user_reactivated: "User reactivated",
  user_force_logout: "Force logout",
  role_assigned: "Role assigned",
  role_revoked: "Role revoked",
  role_created: "Role created",
  role_updated: "Role updated",
  role_deleted: "Role deleted",
  permission_granted: "Permission granted",
  permission_revoked: "Permission revoked",
  employee_created: "Employee created",
  employee_updated: "Employee updated",
  employee_deactivated: "Employee deactivated",
  location_created: "Location created",
  location_updated: "Location updated",
  module_accessed: "Module access",
  record_created: "Record created",
  record_updated: "Record updated",
  record_deleted: "Record deleted",
};

export const getEventBadge = (eventKey, category) => {
  const label =
    EVENT_LABEL[eventKey] ||
    (eventKey
      ? eventKey.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase())
      : "—");
  const color = CATEGORY_COLOR[category] || "default";
  return { label, color };
};
